import type { LibraryItem, MediaRef, MediaPreview, MediaType, LibraryCollection } from "../types";

import { LoadingSpinner } from "./LoadingSpinner";
import { MediaCard } from "./MediaCard";

import styles from "./MediaGrid.module.css";

interface MediaGridProps {
    items: MediaPreview[];
    loading: boolean;
    activeTab: MediaType;
    library: LibraryItem[];
    updateCollection: (ref: MediaRef, target: LibraryCollection) => void;
    onOpenModal: (id: number, type: MediaType) => void;
}

export const MediaGrid = ({
    items, loading, activeTab,
    library, updateCollection, onOpenModal
}: MediaGridProps) => {

    return (
        <div className={styles.mediaGridWrapper}>
            {loading && <div className={styles.overlay}><LoadingSpinner size="lg" fullPage /></div>}
            {!loading && items.length === 0 ? (
                <div className={styles.emptyState}>
                    Aucun résultat trouvé
                </div>
            ) : (
                <div className={styles.mediaGrid}>
                    {items.map(item => (
                        <div
                            key={`${item.media_type}-${item.id}`}
                            className="media-card-wrapper"
                            onClick={() => onOpenModal(item.id, (item.media_type as MediaType) || activeTab)}
                        >
                            <MediaCard
                                item={item}
                                library={library}
                                updateCollection={updateCollection}
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};